import serviceApi from 'services/api';
import auth from 'services/auth';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

/* The AdminProps type represents the properties of an admin, including its UUID, username, password and role, accountUuid, 
buildingUuid and organizationUuid. */
export type AdminProps = {
  uuid?: string;
  username: string;
  password: string;
  role: string;
  accountUuid?: string;
  buildingUuid?: string;
  organizationUuid?: string;
};

/* The function `findAllAdmins` makes an asynchronous API call to retrieve a list of admin users and returns the data. */
const findAllAdmins = async () => {
  const response = await api.get<AdminProps[]>('/apiv1/admin/users');
  return response.data;
};

/* The function creates a new admin user by making a POST request to the '/apiv1/admin/user' endpoint with the provided newAdmin object. */
const createAdmin = async (newAdmin: AdminProps) => {
  const response = await api.post<AdminProps>('/apiv1/admin/user', newAdmin);
  return response?.data;
};

/* The function `findAdminById` is an asynchronous function that retrieves an admin user by their UUID from an API. */
const findAdminById = async (uuid: string | undefined) => {
  const response = await api.get<AdminProps>(`/apiv1/admin/user/${uuid}`);
  return response?.data;
};

/* The function `updateAdmin` is an asynchronous function that updates an admin user with the given UUID using an API call. */
const updateAdmin = async (uuid: string | undefined, updatedAdmin: AdminProps) => {
  const response = await api.put<AdminProps>(`/apiv1/admin/user/${uuid}`, updatedAdmin);
  return response?.data;
};

const AdminService = {
  createAdmin,
  findAllAdmins,
  findAdminById,
  updateAdmin
};

export default AdminService;
